import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var IFrameProtocol = /*#__PURE__*/function () {
  function IFrameProtocol(iframe, origin) {
    _classCallCheck(this, IFrameProtocol);

    // React to messages from any iframe
    this.globalListeners = {};
    this.globalListenersCount = 0; // React to messages from the iframe owned by this instance

    this.channelListeners = {};
    this.channelListenersCount = 0; // Random number to identify this instance of the client when messages are coming from multiple iframes

    this.channelId = Math.floor(Math.random() * 1000000);
    this.frameWindow = iframe.contentWindow;
    this.origin = origin;
    this.globalListeners = [];
    this.channelListeners = [];
    this.eventListener = this.eventListener.bind(this);

    if (typeof window !== "undefined") {
      window.addEventListener("message", this.eventListener);
    }
  }

  _createClass(IFrameProtocol, [{
    key: "cleanup",
    value: function cleanup() {
      window.removeEventListener("message", this.eventListener);
      this.globalListeners = {};
      this.channelListeners = {};
      this.globalListenersCount = 0;
      this.channelListenersCount = 0;
    } // Sends the channelId and triggers an iframeHandshake promise to resolve,
    // so the iframe can start listening for messages (based on the id)

  }, {
    key: "register",
    value: function register() {
      if (!this.frameWindow) {
        return;
      }

      this.frameWindow.postMessage({
        type: "register-frame",
        origin: document.location.origin,
        id: this.channelId
      }, this.origin);
    } // Messages are dispatched from the client directly to the instance iframe

  }, {
    key: "dispatch",
    value: function dispatch(message) {
      if (!this.frameWindow) {
        return;
      }

      this.frameWindow.postMessage(_objectSpread({
        $id: this.channelId,
        codesandbox: true
      }, message), this.origin);
    } // Add a listener that is called on any message coming from an iframe in the page
    // This is needed for the `initialize` message which comes without a channelId

  }, {
    key: "globalListen",
    value: function globalListen(listener) {
      var _this = this;

      if (typeof listener !== "function") {
        return function () {
          return;
        };
      }

      var listenerId = this.globalListenersCount;
      this.globalListeners[listenerId] = listener;
      this.globalListenersCount++;
      return function () {
        delete _this.globalListeners[listenerId];
      };
    } // Add a listener that is called on any message coming from an iframe with the instance channelId
    // All other messages (eg: from other iframes) are ignored

  }, {
    key: "channelListen",
    value: function channelListen(listener) {
      var _this2 = this;

      if (typeof listener !== "function") {
        return function () {
          return;
        };
      }

      var listenerId = this.channelListenersCount;
      this.channelListeners[listenerId] = listener;
      this.channelListenersCount++;
      return function () {
        delete _this2.channelListeners[listenerId];
      };
    } // Handles message windows coming from iframes

  }, {
    key: "eventListener",
    value: function eventListener(message) {
      if (!message.data.codesandbox) {
        return;
      }

      Object.values(this.globalListeners).forEach(function (listener) {
        return listener(message.data);
      });

      if (message.data.$id !== this.channelId) {
        return;
      }

      Object.values(this.channelListeners).forEach(function (listener) {
        return listener(message.data);
      });
    }
  }]);

  return IFrameProtocol;
}();